export default {
  title: 'Receipt printing',
  sections: {
    destination: 'Receipts print to',
  },
  printers: {
    inner: {
      title: 'Built-in printer',
    },
    external: {
      title: 'External printer',
      width_unset: 'Paper width not set',
      connect_hint: 'Connect a printer to use it',
      disconnect_confirm: 'Disconnect this printer?',
      disconnect_confirm_description: 'You’ll have to set it up again.',
      disconnect_confirm_ok: 'Yes, disconnect',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Ready',
      title: 'Ready to print',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Paper low',
      title: 'Paper is nearly out',
      description: 'Replace the roll soon. Printing continues.',
    },
    busy: {
      label: 'Busy',
      title: 'Printer is busy',
      description: '{{name}} is finishing another job.',
    },
    not_configured: {
      label: 'Not set up',
      title: 'Not set up',
      description: '{{name}} needs to be set up before it can print.',
    },
    offline: {
      label: 'Offline',
      title: 'Not printing',
      description: '{{name}} is offline. New orders are not being printed.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} is not connected.',
    },
    cover_open: {
      label: 'Cover open',
      title: 'Cover is open',
      description: 'Close the printer cover to resume printing.',
    },
    paper_empty: {
      label: 'Out of paper',
      title: 'Out of paper',
      description: 'Replace the roll to resume printing.',
    },
    wrong_paper: {
      label: 'Wrong paper',
      title: 'Wrong paper',
      description: 'The loaded roll doesn’t match the configured paper width.',
    },
    cutter_error: {
      label: 'Cutter error',
      title: 'Cutter error',
      description: 'Check the cutter for jammed paper, then retry.',
    },
    overheat: {
      label: 'Too hot',
      title: 'Printer too hot',
      description: 'Let {{name}} cool down before printing again.',
    },
    error: {
      label: 'Error',
      title: 'Printer error',
      description: '{{name}} reported an error and needs attention.',
    },
    connecting: {
      label: 'Connecting…',
      title: 'Connecting…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Not connected',
      title: 'Not connected',
      description: '{{name}} is not connected.',
    },
  },
  form: {
    auto_print: {
      label: 'Print new orders automatically',
      not_ready: 'Auto-print is on but the external printer isn’t ready. Orders won’t print.',
    },
    print_copies: {
      label: 'Copies per order',
      hint: 'Turn on auto-print to set copies',
      decrease: 'Decrease copies',
      increase: 'Increase copies',
    },
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
  },
  buttons: {
    test_print: 'Test print',
    configure_external: 'Configure',
    connect_external: 'Connect a printer',
    disconnect_external: 'Disconnect',
    retry_connection: 'Retry connection',
    cancel: 'Cancel',
  },
};
